import React from 'react';
import SideMenu from '../side-menu';
import { styled } from '../../themes';
import { device } from 'themes/media-queries';
import CookieConsent from 'react-cookie-consent';
import { Location } from '@reach/router';
import { useTranslation } from 'react-i18next';

const Layout = ({ children }) => {
  const [t] = useTranslation();
  return (
    <Location style={{ position: 'relative' }}>
      {locationProps => (
        <div style={{ position: 'relative' }}>
          <Grid>{children}</Grid>
          <SideMenu {...locationProps} />
          <CookieConsent
            buttonText={t('section--cookie-banner.buttonLabel')}
            buttonStyle={{
              backgroundColor: '#eb730b',
              color: 'white',
              fontSize: '13px',
              padding: '1rem 2rem',
              fontWeight: '700',
              borderRadius: '3px',
              marginRight: '100px',
            }}
            style={{ fontSize: '1.5rem' }}
          >
            {t('section--cookie-banner.content')}
          </CookieConsent>
        </div>
      )}
    </Location>
  );
};

const Grid = styled.div`
  display: grid;
  grid-row-gap: 10rem;
  grid-auto-rows: min-content;
  grid-template-columns:
    [full-start] minmax(6rem, 1fr) [semi-full-start] minmax(6rem, 1fr) [center-start]
    repeat(8, [col-start] minmax(min-content, 18rem) [col-end])
    [center-end] minmax(6rem, 1fr) [semi-full-end] minmax(12rem, 1fr) [full-end];

  @media ${device.laptop} {
    grid-template-columns:
      [full-start] minmax(3rem, 1fr) [semi-full-start] minmax(3rem, 1fr) [center-start]
      repeat(8, [col-start] minmax(min-content, 18rem) [col-end])
      [center-end] minmax(3rem, 1fr) [semi-full-end] minmax(3rem, 1fr) [full-end];
  }

  @media ${device.mobileL} {
    grid-template-columns:
      [full-start] minmax(1rem, 1fr) [semi-full-start] minmax(1rem, 1fr) [center-start]
      repeat(8, [col-start] minmax(min-content, 18rem) [col-end])
      [center-end] minmax(1rem, 1fr) [semi-full-end] minmax(1rem, 1fr) [full-end];
  }
`;

export default Layout;
